"use client";

import { useEffect } from "react";

import { analytics } from "@/lib/analytics";

export function MenuDepthAnalytics() {
  useEffect(() => {
    const trackedCategories = new Set<string>();
    const trackedSections = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const element = entry.target as HTMLElement;

          if (element.dataset.analyticsMenuCategory) {
            const category = element.dataset.analyticsMenuCategory;
            const group = element.dataset.analyticsMenuGroup;
            const key = `${group ?? "menu"}:${category}`;

            if (!trackedCategories.has(key)) {
              trackedCategories.add(key);
              analytics.menuCategoryViewed(category);
            }
          }

          if (element.dataset.analyticsSection) {
            const section = element.dataset.analyticsSection;
            const key = `${element.dataset.analyticsPageSection ?? "menu"}:${section}`;

            if (!trackedSections.has(key)) {
              trackedSections.add(key);
              analytics.sectionViewed(section, {
                page_section: element.dataset.analyticsPageSection,
                menu_group: element.dataset.analyticsMenuGroup,
              });
            }
          }

          observer.unobserve(element);
        });
      },
      { rootMargin: "0px 0px -35% 0px", threshold: 0.2 },
    );

    document
      .querySelectorAll<HTMLElement>(
        "[data-analytics-menu-category], [data-analytics-section]",
      )
      .forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return null;
}
